export const closedStoreResponse = 'Closed';